export const userImageQueryKeys = {
  all: ['user-images'] as const,

  currentUser: () => [...userImageQueryKeys.all, 'me'] as const,
  byUserId: (userId: string) => [...userImageQueryKeys.all, 'by-id', userId] as const
};
